
//-------------- Gallery -------------- //

// Slick Slider - set parameters (Ref: http://kenwheeler.github.io/slick/)
var slickSliderSettings = {
  adaptiveHeight: true,
  mobileFirst: true,
	//autoplay: true,
	autoplaySpeed: 10000,
	cssEase: 'cubic-bezier(0.230, 1.000, 0.320, 1.000)', // $ease_out_quint
	dots: true,
	arrows: true,
  nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"></button>', // remove text from button
  prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"></button>', // remove text from button
	draggable: true,
	swipe: true,
  swipeToSlide: true,
  touchThreshold: 200,
  //verticalSwiping: true,
  touchMove: true,
	infinite: true,
	pauseOnFocus: true,
	pauseOnDotsHover: true,
	slidesToShow: 1,
	speed: 300,
	waitForAnimate: true,
	responsive: [ // More swipe-friendly on mobile
    // {
    //   breakpoint: 1199,
    //   settings: {
    //     cssEase: 'ease',
		// 		speed: 300
    //   }
    // },
		{
      breakpoint: 991, // desktop
      settings: {
        dots: false,
        arrows: false,
				speed: 300,
        fade: true,
        waitForAnimate: false
        //slickFilter: '.video-slide'
      }
    }
	]
};
if( $('.slider').length ) {
  $('.slider').slick(slickSliderSettings);
  $('.slider').removeClass('loading'); // Show slider after fully loaded
  //$('.slick-slide').bind('touchstart', function(){ console.log('touchstart'); });
}


// Resize thumbnails (Desktop)
function resizeThumbnails() {
  var thumbnailsContainerHeight = $('#product-gallery .gallery-thumbnails').outerHeight();
  var thumbnailCount = $('#product-gallery .gallery-thumbnails .gallery-thumbnail').length;
  var thumbnailMargin = parseInt($('#product-gallery .gallery-thumbnails .gallery-thumbnail').css('margin-bottom'));
  var newThumbnailHeight = ((thumbnailsContainerHeight + thumbnailMargin) / thumbnailCount) - thumbnailMargin;
  newThumbnailHeight = newThumbnailHeight > 80 ? 80 : newThumbnailHeight; // max at 80px
  $('#product-gallery .gallery-thumbnails .gallery-thumbnail').css({
    'height': newThumbnailHeight,
    'width': newThumbnailHeight
  });
  // if thumbnail are smaller than 50px remove video label
  if (newThumbnailHeight < 50) {
    $('#product-gallery .gallery-thumbnails .video-thumbnail').addClass('small');
  } else {
    $('#product-gallery .gallery-thumbnails .video-thumbnail').removeClass('small');
  }
  $('#product-gallery .gallery-thumbnails').removeClass('loading');

  // Resize breadcrumb padding based on thumbnail size
  var breadcrumbs = document.querySelector(".breadcrumbs");
  if (breadcrumbs) {
    var paddingLeft = 80 - newThumbnailHeight;
    if (window.innerWidth >= 1400) { // Desktop large
      breadcrumbs.style.paddingLeft = `calc(3.5% + ${paddingLeft}px)`;
    } else if (window.innerWidth > 991) { // Desktop
      breadcrumbs.style.paddingLeft = `${paddingLeft}px`;
    } else {
      breadcrumbs.style.paddingLeft = "0px";
    }
    breadcrumbs.classList.remove('loading');
  }
}


//resizeThumbnails();
$(document).ready(function() { resizeThumbnails(); });
$(window).resize(function() { resizeThumbnails(); });


// Gallery slider video dots
$('#product-gallery .gallery-thumbnails .gallery-thumbnail').each( function(i) {
  if ($(this).hasClass('video-thumbnail')) {
    $('#product-gallery .display-box .slider').find('.slick-dots').children().eq(i).children('button').addClass('video-dot');
  }
});

// Increase slider image resolutions (once only)
function loadSliderImageRes() {
  $('#product-gallery .slider').find('.slick-slide').each(function() {
    var imageTag = $(this).find('img[data-src-manual]');
    var sourceTag = $(this).find('source[data-srcset-manual]');
    imageTag.attr('src', imageTag.attr('data-src-manual'));
    sourceTag.attr('srcset', sourceTag.attr('data-srcset-manual'));
    // Load videos
    let videoTag = $(this).find('video');
    if(videoTag.length) {
      let videoSourceTag = videoTag.find('source');
      videoSourceTag.attr('src', videoSourceTag.attr('data-src-manual'));
      videoTag[0].load();
    }
  });
  imageResLoaded = true;
}

// Change gallery on thumbnail select (Desktop)
$('#product-gallery .gallery-thumbnail').off().mouseenter( function(e) {
  // Adding conditional to make sure that it doesn't change
  // when you're spinning the spin view

  // 360 Images
  // if (window.spinViewEligible) {
  //   // Make the slider visible if it isn't already
  //   if (document.querySelector('#product-gallery .slider').classList.contains('fade-out')) {
  //     // document.querySelector('#product-gallery .slider').style.display = 'block'
  //     document.querySelector('#product-gallery .slider').classList.remove('fade-out')
  //   }
  //   // Make the 360 frame inactive if it isn't already
  //   if (document.querySelector('#spin-view-desktop').classList.contains('fade-out') === false) {
  //     // document.querySelector('#spin-view-desktop').style.display = 'none'
  //     document.querySelector('#spin-view-desktop').classList.add('fade-out')
  //   }
  // }

  $('#product-gallery .slider').slick('slickGoTo',$(this).index());
  $(this).siblings().removeClass('active');
  $(this).addClass('active');
});

// Activate thumbnail on gallery slider change
$('#product-gallery .slider').on('afterChange', function() {
  var currentSlide = $('.slick-current').attr('data-slick-index');
  $('#product-gallery .gallery-thumbnail').removeClass('active');
  $('#product-gallery .gallery-thumbnail').eq(currentSlide).addClass('active');
});

// Before slider change
$('#product-gallery .slider').on('beforeChange', function() {
  // Increase slider image resolution on first slide only
  if (imageResLoaded == false) {
    loadSliderImageRes();
  }
  // For desktop, prevent panning after slide change
  $(this).unbind('mousemove');
});

// After slider change
$('#product-gallery .slider').on('afterChange', function() {
  // Pause all videos
  $('#product-gallery .slider').find('.slick-slide video').each( function() {
    $(this)[0].pause();
  });
  var currentSlide = $('#product-gallery .slider').find('.slick-active');
  // If this slide has a video, play video
  if (currentSlide.children('video').length > 0) {
    var video = currentSlide.children('video');
    video[0].play(); // Play video object
  }
  // Update zoom overlay image to match current slide image
  var currentSlideImageUrl = currentSlide.find('source').attr('srcset');
  var currentSlideImageRes = currentSlide.find('source').attr('data-res');
  $('#product-gallery .image-zoom-overlay').find('source').attr({
    'srcset': currentSlideImageUrl,
    'data-res': currentSlideImageRes
  });
});

// Image hover zoom (desktop)
$('#product-gallery .display-box').hover( function(e) {
  if( window.innerWidth > desktopBreakPoint ) { // Desktop only
    if (imageResLoaded == false) {
      loadSliderImageRes();
    }
    var slider = $(this).find('.slider');
    var slide = slider.find('.slick-slide.slick-active');
    var sliderWidth = slider.outerWidth();
    var sliderHeight = slider.outerHeight();
    if (slide.find('img').length) { // only apply to images, not videos
      // Zoom in
      slide.addClass('hover-zoom');
      // Boost image resolution
      var image = slide.find('img');
      var imageRes = image.attr('data-res');
      var maxRes = '2000x2000';
      image.attr('src', image.attr('src').replace(imageRes, maxRes));
      // Pan image with mouse
      slider.mousemove(function(e){
        var offset = slider.offset();
        var x = e.pageX - offset.left;
        var y = e.pageY - offset.top;
        // Get percentage distance from centre of slide to pointer
        var pcXCenter = ((sliderWidth/2)-x) / sliderWidth * 100 * 1;
        pcXCenter = pcXCenter.toFixed(1);
        var pcYCenter = ((sliderHeight/2)-y) / sliderWidth * 100 * 1;
        pcYCenter = pcYCenter.toFixed(1);
        // Move slide according to X,Y percentages
        slide.css({
          '-webkit-transform' : 'translate(' + pcXCenter + '%, ' + pcYCenter + '%)',
          '-moz-transform'    : 'translate(' + pcXCenter + '%, ' + pcYCenter + '%)',
          'transform'         : 'translate(' + pcXCenter + '%, ' + pcYCenter + '%)'
        });
      });
    }
  }
},function(e) {
  // Reset all on hover off
  if( window.innerWidth > desktopBreakPoint ) { // Desktop only
    $(this).find('.slider .slick-slide').removeClass('hover-zoom').css({
      '-webkit-transform' : 'translate(0, 0)',
      '-moz-transform'    : 'translate(0, 0)',
      'transform'         : 'translate(0, 0)'
    });
  }
});




// Image gesture interaction (mobile) - https://interactjs.io/

if( $('.slider').length ) {

  // Set variables (no use of const as strict mode is enabled by slick/interact)
  var zoomImageOverlay = document.querySelector('#product-gallery .image-zoom-overlay');
  var zoomImageContainer = zoomImageOverlay.querySelector('.inner');
  var zoomImage = zoomImageContainer.querySelector('img');
  var zoomImageSource = zoomImageContainer.querySelector('source');
  var zoomImagePosX = 0;
  var zoomImagePosY = 0;
  var zoomImageScale = 1;
  var currentScale = 1;
  var zoomImageRes = zoomImage.getAttribute('data-res');
  var maxRes = '2000x2000';
  var doubleTapZoomScale = 2;
  var positioning = {};
  var itemInMotion = false;

  // Listen for gesture on current slider image
  function gestureListener(event) {

    interact('.slick-current').gesturable({
      onstart: function (event) {
        document.body.addEventListener("touchmove", function(e){ e.preventDefault(); }); // Prevent (touch) scrolling while gesturing
        if (event.currentTarget.getElementsByTagName('img').length) { // for images only, not video
          overlayActive(event.currentTarget.getElementsByTagName('img'));
        }
        // Make active on move
        zoomImageContainer.classList.add('gesture-active');
      },
      onmove: function (event) {
        if (event.currentTarget.getElementsByTagName('img').length) { // for images only, not video
          // Define new scale
          currentScale = event.scale * zoomImageScale;
          // Restrict scale
          if (currentScale > 3) { currentScale = 3; } // Not greater than 3x default size
          else if (currentScale < 0.8) { currentScale = 0.8; } // Not smaller than default size
          // Apply scale changes
          zoomImage.style.webkitTransform = zoomImage.style.transform = 'scale(' + currentScale + ')';
          // Allow drag together with gesture
          dragMoveListener(event);
        }
      },
      onend: function (event) {
        boostImageRes();
        zoomImageContainer.classList.remove('gesture-active');
        zoomImageScale = currentScale;
        if (zoomImageScale < 1.2) { // Not smaller than default size
          zoomImageScale = 1;
          zoomOverlayClose(); // Close if scale is back to 1 or below
        }
        document.body.addEventListener("touchmove", function(e){ e.returnValue = true; }); // Allow normal touch events after gesturing
      }
    }).on('doubletap', function (event) {
      if (event.currentTarget.getElementsByTagName('img').length) { // for images only, not video
        event.currentTarget.classList.remove('gesture-active');
        overlayActive(event.currentTarget.getElementsByTagName('img'));
        zoomImage.style.webkitTransform = zoomImage.style.transform = 'scale(' + doubleTapZoomScale + ')';
        zoomImageScale = doubleTapZoomScale;
        boostImageRes();
      }
    }); // end gesturable()

    function overlayActive(activeSlideImage) {
      // Position zoom image
      positioning.top = activeSlideImage[0].getBoundingClientRect().top + 'px';
      positioning.left = activeSlideImage[0].getBoundingClientRect().left + 'px';
      positioning.width = activeSlideImage[0].getBoundingClientRect().width + 'px';
      positioning.height = activeSlideImage[0].getBoundingClientRect().height + 'px';
      Object.assign(zoomImageContainer.style, positioning);
      // Show zoom overlay
      zoomImageOverlay.classList.add('active');
    }

    function boostImageRes() {
      if(zoomImageSource) {
        zoomImageRes = zoomImageSource.getAttribute('data-res');
        zoomImageSource.srcset = zoomImageSource.srcset.replace(zoomImageRes, maxRes);
      } else {
        zoomImageRes = zoomImage.getAttribute('data-res');
        zoomImage.src = zoomImage.src.replace(zoomImageRes, maxRes);
      }
    }

  }
  // Call on current slide
  gestureListener('.slick-current');



  // Functions for zoom overlay

  function dragMoveListener (event) {

    zoomImageContainer.classList.add('gesture-active');

    var target = zoomImageContainer;
    // keep the dragged position in the data-x/data-y attributes
    zoomImagePosX = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
    zoomImagePosY = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
    // translate the element
    target.style.webkitTransform =
    target.style.transform = 'translate(' + zoomImagePosX + 'px, ' + zoomImagePosY + 'px)';
    // update the posiion attributes
    target.setAttribute('data-x', zoomImagePosX);
    target.setAttribute('data-y', zoomImagePosY);

    // If dragged out of bounds
    var displacedX = Math.abs(zoomImagePosX/(zoomImageScale/2));
    var displacedY = Math.abs(zoomImagePosY/(zoomImageScale/2));

    if (displacedX >= window.innerWidth || displacedY >= window.innerHeight) {
      if (!itemInMotion) { // Call once only per motion
        zoomImageOverlay.classList.add('out-of-bounds');
        setTimeout( function() {
          zoomOverlayClose();
          zoomImageOverlay.classList.remove('out-of-bounds');
        }, 400); // transition time
        itemInMotion = true;
      }
    }

  } // end dragMoveListener()

  function makeInteractable(event) {

    interact(zoomImageContainer).gesturable({

      onstart: function (event) {
        // Prevent (touch) scrolling while gesturing
        zoomImageOverlay.addEventListener("touchmove", function(e){ e.preventDefault(); });
        // Make active on move
        zoomImageContainer.classList.add('gesture-active');
      },
      onmove: function (event) {
        // Define new scale
        currentScale = event.scale * zoomImageScale;
        // Restrict scale
        if (currentScale > 3) { currentScale = 3; } // Not greater than 3x default size
        else if (currentScale < 0.8) { currentScale = 0.8; } // Not smaller than default size
        // Apply scale changes
        zoomImage.style.webkitTransform = zoomImage.style.transform = 'scale(' + currentScale + ')';
        // Allow drag together with gesture
        dragMoveListener(event);
      },
      onend: function (event) {
        // Remove active class
        zoomImageContainer.classList.remove('gesture-active');
        // Restrict scale
        zoomImageScale = currentScale;
        if (zoomImageScale < 1.2) { // Not smaller than default size
          zoomOverlayClose(); // Close if scale is back to 1 or below
        }
        // Allow normal touch events after gesturing
        zoomImageOverlay.addEventListener("touchmove", function(e){ e.returnValue = true; });
      }

    }).draggable({
      inertia: {
        resistance: 10
      },
      onstart: function (event) {
        // Prevent (touch) scrolling while gesturing
        zoomImageOverlay.addEventListener("touchmove", function(e){ e.preventDefault(); });
      },
      onmove: dragMoveListener,
      onend: function (event) {
        // Reset motion status
        itemInMotion = false;
        // Allow normal touch events after gesturing
        zoomImageOverlay.addEventListener("touchmove", function(e){ e.returnValue = true; });
     }

    }).on('doubletap', function (event) {
      zoomOverlayClose(); // Close on double tap
    }); // end gesturable/draggable/doubletap

  } // end makeInteractable()

  // Call on zoom image container
  makeInteractable(zoomImageContainer);


  function resetGesture() {
    zoomImageContainer.classList.remove('gesture-active');
    zoomImageContainer.style.webkitTransform = zoomImageContainer.style.transform = 'translateX(0) translateY(0)';
    zoomImageContainer.setAttribute('data-x', '0');
    zoomImageContainer.setAttribute('data-y', '0');
    zoomImage.style.webkitTransform = zoomImage.style.transform = 'scale(1)';
    zoomImageScale = 1;
  }

  function zoomOverlayClose() {
    resetGesture();
    zoomImageOverlay.classList.remove('active');
  }

  // Close button
  zoomImageOverlay.querySelector('.close').addEventListener('click', function(e){
    zoomOverlayClose();
  });

  // Tap on dark underlay to close
  zoomImageOverlay.addEventListener('click', function(e){
    if (zoomImage !== e.target) {
      zoomOverlayClose();
    }
  });


} // end if .slider


/*

// Spin Viewer Stuff
function spinViewerMobile() {
  const url = 'https://juoij9lpql.execute-api.eu-west-1.amazonaws.com/dev/spin-view/check-id'
  // This button will only be here if the tag is on the product
  const button = document.getElementById('spin-view-mobile-trigger');
  const modal = document.getElementById('spin-view-mobile-modal');
  const modalClose = document.querySelector('#spin-view-mobile-modal .close-btn');
  // const desktopThumbnails = document.querySelectorAll('#spin-view-desktop');
  // desktopThumbnails.forEach(d => d.outerHTML = '')
  if (button && modal) {
    const pid = button.getAttribute('data-pid');
    if (pid) {
      const body = {
        product_id: pid
      }
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)

      })
      .then(response => response.json())
      .then(data => {
        if (data !== 'Unsupported') {
          // Check the download speed to make sure the device can handle the image load
          checkDownloadSpeed('https://chupi-360-images.s3-eu-west-1.amazonaws.com/dl_speed_test.jpg', 44663)
          .then((mbs) => {
            if (window.location.href.indexOf('dev') > 1) console.log(mbs);
            if (mbs > 0.2) {
              window.spinViewEligible = true;
              if (window.location.href.indexOf('dev') > 1) console.log('Init spin view');
              // Make the button visible
              button.classList.remove('inactive');
              window.setTimeout(() => button.classList.add('visible'), 500);
              const spinView = new SpinViewer('#spin-view-mobile', pid);
              button.addEventListener('click', () => {
                // Only initialise on the trigger click
                if (spinView.initialised === false) {
                  spinView.init();
                }
                modal.classList.add('active');
                // If GorgiasChat enabled, hide on open
                try {
                  handleFixedElements('hide');
                } catch (err) {
                  
                }
                // Lock the body here to avoid unpleasant scrolling while swiping
                if (modal.classList.contains('active')) {
                  document.body.style.height = '100vh';
                  document.body.style.width = '100vw';
                  document.body.style.overflow = 'hidden';
                }
              })
              // Make body scrollable again
              modalClose.addEventListener('click', () => {
                document.body.style.height = 'auto';
                document.body.style.width = 'auto';
                document.body.style.overflow = 'visible';
                // If GorgiasChat enabled, hide on open
                try {
                  handleFixedElements('hide');
                } catch (err) {

                }
              })
            } else {
              if (window.location.href.indexOf('dev') > 1) console.log('Slow connection, fallback');
              // Fallback here
            }
          });
        }
      })
    }
  }
}

function spinViewerDesktop() {
  const url = 'https://juoij9lpql.execute-api.eu-west-1.amazonaws.com/dev/spin-view/check-id'
  // This frame will only be here if the tag is on the product
  const frame = document.getElementById('spin-view-desktop');
  const thumbnail = document.getElementById('spin-view-desktop-thumbnail');
  if (frame && thumbnail) {
    const pid = frame.getAttribute('data-pid');
    if (pid) {
      const body = {
        product_id: pid
      }
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)

      })
      .then(response => response.json())
      .then(data => {
        if (data !== 'Unsupported') {
          // Check the download speed to make sure the device can handle the image load
          checkDownloadSpeed('https://chupi-360-images.s3-eu-west-1.amazonaws.com/dl_speed_test.jpg', 44663)
          .then((mbs) => {
            if (window.location.href.indexOf('dev') > 1) console.log(mbs);
            if (mbs > 0.6) {
              window.spinViewEligible = true;
              thumbnail.classList.add('initialised');
              if (window.location.href.indexOf('dev') > 1) console.log('Init spin view');
              // Make the thumbnail visible
              const spinView = new SpinViewer('#spin-view-desktop', pid);
              thumbnail.addEventListener('mouseenter', () => {
                // Only initialise on the trigger mouseover
                document.querySelector('.slick-slider').classList.add('fade-out')
                frame.classList.remove('fade-out')
                if (spinView.initialised === false) {
                  spinView.init();
                }
              })
            } else {
              if (window.location.href.indexOf('dev') > 1) console.log('Slow connection, fallback');
              // Hide the thumbnail
              thumbnail.style.display = 'none';
            }
          });
        }
      })
    }
  }
}

// window.addEventListener('load', function(){
//   // if ()
//   if (window.innerWidth < 991) {
//     spinViewerMobile();
//   } else {
//     spinViewerDesktop();
//   }
// });

let mobileSpinVersion = window.innerWidth < 991;

// Check if spin view is there
window.addEventListener('resize', function(){
  if (window.spinViewEligible) {
    if (window.innerWidth > 991 && mobileSpinVersion === true) {
      if (window.location.href.indexOf('dev') > 1) console.log('Switched to desktop')
      // Remove the mobile spin view elements and run the desktop version
      document.getElementById('spin-view-mobile-trigger').classList.remove('visible');
      document.getElementById('spin-view-mobile-trigger').classList.add('inactive');
      document.getElementById('spin-view-desktop').style.display = 'block';
      // document.getElementById('spin-view-wrap').style.display = 'none';
      spinViewerDesktop();
      mobileSpinVersion = false
    } else if (window.innerWidth < 991 && mobileSpinVersion === false) {
      if (window.location.href.indexOf('dev') > 1) console.log('Switched to mobileSpinVersion')
      // Remove the desktop spin view elements and run the mobile version
      document.getElementById('spin-view-desktop').style.display = 'none';
      document.getElementById('spin-view-desktop-thumbnail').classList.remove('initialised');
      // Remove the fadeout class from the slider if it's there
      document.querySelector('.display-box .slider').classList.remove('fade-out');
      spinViewerMobile();
      mobileSpinVersion = true
    }
  }
});

function spinViewAbTest() {
  try {
    var srcs = [
      'https://cdn.shopify.com/s/files/1/1090/1794/files/Chupi-Solid-Gold-Ring-My-Heart-Is-Open-vg.m4v?4012645479057254056',
      'https://cdn.shopify.com/s/files/1/1090/1794/files/Chupi-Solid-Gold-Necklace-Initial-Letter-Tiny.mp4?1024286564782638644',
      'https://cdn.shopify.com/s/files/1/1090/1794/files/Chupi-Solid-Gold-Ring-North-Star-Tiny-Signet.mp4?1622'
    ]
    srcs.forEach(function(s) {
      // Get the first video if it exists
      var video = document.querySelector(`video[src="${s}"]`);
      if (video) {
        // Remove the thumbnail if it's there
        const thumbnail = document.querySelector(`.video-thumbnail[data-video-url="${s}"]`)
        if (thumbnail) {
          thumbnail.outerHTML = '';
        }
        // Remove that slide
        var slideIndex = video.parentElement.getAttribute('data-slick-index');
        $('.slider').slick('slickRemove', slideIndex)
        $('#product-gallery .gallery-thumbnails .gallery-thumbnail').each( function(i) {
          if ($(this).hasClass('video-thumbnail')) {
            $('#product-gallery .display-box .slider').find('.slick-dots').children().eq(i).children('button').addClass('video-dot');
          }
        });
      }
    })
    if (window.innerWidth < 991) {
      spinViewerMobile();
    } else {
      spinViewerDesktop();
    }
    resizeThumbnails();
  } catch (e) {
    console.log(e)
  }
}

// if(document.readyState === "complete") {
//   spinViewAbTest();
// } else {
//   window.addEventListener("onload", spinViewAbTest, false);
// }

*/